import { inject } from "fw";
import { Store, handle } from "fw-state";
import { AlarmsRepository } from "network/alarms-repository";
import { AlarmsTripped } from "../models/alarms";
import { StartAction } from "./actions";

type CurrentAlarmsStoreShape = {
    alarmsNotifications: AlarmsTripped;
    alarmsNotificationsAnimation: boolean;
    errorLoading: boolean;
};

export class FetchAlarmsNotificationsAction {}

@inject
export class NotificationsStore extends Store<CurrentAlarmsStoreShape> {
    constructor(private network: AlarmsRepository) {
        super();
    }

    defaultState() {
        return {
            alarmsNotifications: null,
            alarmsNotificationsAnimation: false,
            errorLoading: false
        };
    }

    @handle(StartAction)
    private handleStartAction(action: StartAction) {
        this.setState(() => ({ ...this.defaultState() }));
    }

    @handle(FetchAlarmsNotificationsAction)
    private async handleAlarmsNotificationsAction(action: FetchAlarmsNotificationsAction) {
        try {
            const alarmsNotifications = await this.network.getTrippedAlarms();
            this.setState((state) => ({
                ...state,
                loaded: true,
                alarmsNotifications,
                alarmsNotificationsAnimation:
                    alarmsNotifications.LatestStateUpdateUtc && alarmsNotifications.LatestStateUpdateUtc !== state.alarmsNotifications?.LatestStateUpdateUtc
            }));
        } catch (err) {
            this.setState((state) => ({ ...state, errorLoading: true }));
        }

        this.checkShowNotificationsAnimation();
    }

    private checkShowNotificationsAnimation() {
        if (!this.state.alarmsNotificationsAnimation) return;

        setTimeout(() => {
            this.setState((state) => ({ ...state, alarmsNotificationsAnimation: false }));
        }, 5000);
    }
}
